<span class="course-notification-overview d-inline-block">
    <button (click)="toggleOverlay()" class="course-notification-overview-toggle">
        <fa-icon [icon]="faBell" />

        <jhi-course-notification-bubble class="course-notification-overview-bubble" [totalAmount]="courseNotificationCount()" [isSmall]="true" />
    </button>

    <div [ngClass]="isShown() ? 'is-shown' : ''" class="course-notification-overview-overlay">
        <div class="course-notification-overview-triangle"></div>

        <div class="course-notification-overview-headline-button-wrap mb-2">
            <h4 class="course-notification-overview-overlay-headline mb-0" jhiTranslate="artemisApp.courseNotification.overview.title"></h4>

            <div class="course-notification-overview-header-actions">
                @if (selectableSettingPresets(); as selectableSettingPresets) {
                    <jhi-course-notification-preset-picker
                        [availableCourseSettingPresets]="selectableSettingPresets"
                        [selectedCourseSettingPreset]="selectedSettingPreset()"
                        [isSmallButton]="true"
                        (onPresetSelected)="presetSelected($event)"
                    />
                }
                <button
                    pButton
                    severity="secondary"
                    [outlined]="true"
                    size="small"
                    [routerLink]="['/courses', courseId(), 'settings']"
                    [pTooltip]="'artemisApp.courseNotification.overview.settingsTooltip' | artemisTranslate"
                    (click)="closeOverlay()"
                >
                    <fa-icon [icon]="faCog" />
                </button>
            </div>
        </div>

        <div class="course-notification-overview-category-wrap pb-1">
            @for (category of courseCategories(); track category) {
                @if (isCategoryVisible(category)) {
                    <div (click)="selectCategory(category)" [ngClass]="isCategorySelected(category) ? 'is-selected' : ''" class="course-notification-overview-category">
                        <span [jhiTranslate]="'artemisApp.courseNotification.category.' + category.toString().toLowerCase()"></span>
                    </div>
                }
            }
            <button
                id="mark-all-as-read-button"
                pButton
                [text]="true"
                size="small"
                (click)="markAllAsReadClicked()"
                class="course-notification-overview-mark-all-as-read"
                jhiTranslate="artemisApp.courseNotification.overview.markAllAsRead"
            ></button>
        </div>

        <div #scrollContainer class="course-notification-overview-notification-container">
            @if (!isLoading()) {
                @if (notificationsForSelectedCategory().length > 0) {
                    <div>
                        @for (notification of notificationsForSelectedCategory(); track notification) {
                            <div class="notification-animation-wrapper" animate.enter="notification-item-entering" animate.leave="notification-item-leaving">
                                <div class="course-notification-overview-notification-wrap">
                                    <jhi-course-notification
                                        [courseNotification]="notification"
                                        [isUnseen]="notification.status === CourseNotificationViewingStatus.UNSEEN"
                                        [isShowClose]="true"
                                        [isRedirectToUrl]="true"
                                        [fluid]="true"
                                        (onCloseClicked)="closeClicked(notification)"
                                    />
                                </div>
                            </div>
                        }
                        <div class="py-1"></div>
                    </div>
                } @else {
                    <div class="course-notification-overview-notification-empty-prompt">
                        <fa-icon class="course-notification-overview-notification-empty-prompt-icon" [icon]="faEnvelopeOpen" />
                        <div class="mt-3 text-secondary">
                            <strong jhiTranslate="artemisApp.courseNotification.overview.emptyTitle"></strong>
                        </div>
                        <div class="text-secondary text-center">
                            <span jhiTranslate="artemisApp.courseNotification.overview.emptyMessage"></span>
                        </div>
                    </div>
                }
            } @else {
                <div class="course-notification-overview-notification-loading">
                    <fa-icon [icon]="faSpinner" animation="spin" />
                </div>
            }
        </div>
    </div>
</span>
